import { isArray } from 'util';
import { sortByString, mapCollection } from '../../utils/collection.utils';
import { SaleOrderDepartureReason } from '../sale-order-departure-reason';

export class SaleOrderDepartureReasonBuilder {

  static fromJson(json): SaleOrderDepartureReason {
    return (json) ? new SaleOrderDepartureReason(
      json.hash,
      json.name
    ) : null;
  }

  static fromJsonList(list): SaleOrderDepartureReason[] {
    return (isArray(list)) ? sortByString('name', mapCollection(SaleOrderDepartureReasonBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-order-departure-reason.builder.ts